if (!customElements.get('table-toggle')) {
  customElements.define(
    'table-toggle',
    class TableToggle extends HTMLElement {
      constructor() {
        super();
        this.toggleSwitch = this.querySelector('.product-table-switch__wrapper');
        this.imperialTable = this.querySelector('.table-responsive[data-unit-system="imperial"]');
        this.metricTable = this.querySelector('.table-responsive[data-unit-system="metric"]');
        if (this.toggleSwitch) {
          this.toggleSwitch.addEventListener('click', this.swapTables.bind(this));
        }
      }

      swapTables(event) {
        const T_swich = this.toggleSwitch;
        const iTable = this.imperialTable;
        const mTable = this.metricTable;

        T_swich.classList.toggle('metric');

        if( T_swich.classList.contains('metric') ) {
          iTable.style.display = 'none';
          mTable.style.display = 'block';
        } else {
          iTable.style.display = 'block';
          mTable.style.display = 'none';
        }
      }
    }
  );
}
